// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__xC-R9","input":"Search_input__xHhUE","icon":"Search_icon__x8-7x"};